import { render } from "./SiteAccordion.vue?vue&type=template&id=45e6f25b&scoped=true"
import script from "./SiteAccordion.vue?vue&type=script&lang=js"
export * from "./SiteAccordion.vue?vue&type=script&lang=js"

import "./SiteAccordion.vue?vue&type=style&index=0&id=45e6f25b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e6f25b"]])

export default __exports__